import { TournamentActivityState } from './interfaces';
import { TournamentActivityStoreStatus } from './enums';

export const initialState: TournamentActivityState = {
  entity: {},
  status: {
    [TournamentActivityStoreStatus.Loading]: [],
  },
};
